import { useEffect, useState } from 'react'
import CustomerValidationService from 'external-services/customer-validation-service/customerValidation.service'
import { PHONE_ERROR_MESSAGE } from 'external-services/customer-validation-service/types'
import PhoneNumberService from 'external-services/phone-number-service';
import { phoneNumberTypes } from "external-services/phone-number-service/phoneNumber.types";

type ITouched = Record<string, boolean>
type IChangeFunc = (key: string, value: any) => void

const useForm = <T>(defaultValues: T, triggerBookedByValidation: number, onValuesChange?: IChangeFunc, isSurnameRequired?: boolean) => {
  const [values, setValues] = useState<T>(defaultValues)
  const [errors, setErrors] = useState<Record<keyof T, string> | undefined>(undefined)
  const [toucheds, setToucheds] = useState(Object.keys(values).reduce((result: ITouched, cur: string): ITouched => {
    return {
      ...result,
      [cur]: false
    }
  }, {}))

  const setValue = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const { name, value, checked, type } = event.target
    const isCheckbox = type === 'checkbox'

    const output = isCheckbox ? checked : value

    setToucheds({
      ...toucheds,
      [name]: true
    })
    onValuesChange(name, output)
    const newValue = {
      ...values,
      [name]: output
    }
    if (name === 'phone' && !output) {
      onValuesChange('notifySms', false)
      // @ts-ignore
      newValue.notifySms = false
    }
    if (name === 'email' && !output) {
      onValuesChange('notifyEmail', false)
      // @ts-ignore
      newValue.notifyEmail = false
    }
    setValues(newValue)
  }

  useEffect(() => {
    setErrors(getErrors(values, triggerBookedByValidation, isSurnameRequired))
  }, [values, triggerBookedByValidation, isSurnameRequired])
  useEffect(() => {
    setValues(defaultValues)
  }, [defaultValues]);

  return {values, setValue, errors}
}

const getErrors = (values: any, triggerBookedByValidation: number, isSurnameRequired?: boolean): any => {
  const errors = {}
  const { email, firstName, lastName, phone } = values
  const {
    nationalNumber,
    country
  } = PhoneNumberService.parseNumber(phone || '') || {nationalNumber: '', country: null}
  const isPhoneRequired = !email && !nationalNumber
  if(!email && !nationalNumber && !!triggerBookedByValidation) {
    Object.assign(errors, isPhoneRequired
      ? {
        phone: 'A phone or email is required',
        email: 'A phone or email is required'
      }
      : {
        phone: undefined,
        email: undefined
      })
  }

  const isNameRequired = !!triggerBookedByValidation && (!firstName && !lastName)
  const surnameRequired = !!triggerBookedByValidation && !lastName && isSurnameRequired;

  Object.assign(errors, isNameRequired
    ? {
      firstName: surnameRequired ? 'A first name is required' : 'A first or surname is required',
      lastName: surnameRequired ? 'A last name is required' : 'A first or surname is required'
    }
    : {
      firstName: undefined,
      lastName: undefined
    })

  Object.assign(errors, surnameRequired
    ? {
      lastName: 'A last name is required'
    }
    : {
      lastName: undefined
    })

  if (email) {
    const { isEmailValid, emailErrorMsg } = CustomerValidationService.emailValidationCheck(email, false)
    Object.assign(errors, {
      email: isEmailValid ? undefined : emailErrorMsg
    })
  }

  if (nationalNumber) {
    const isValidPhone = PhoneNumberService.formatNumber(nationalNumber, country, true, phoneNumberTypes.INTERNATIONAL)
    Object.assign(errors, {
      phone: isValidPhone ? undefined : PHONE_ERROR_MESSAGE
    })
  }
  return errors
}

export default useForm
